import {
  getCustomerRegistrationSponsorDetailsSponsorInfo,
  type ApiClient,
  type GlobalCustomerRegistrationsRegistrationSponsorInfoDto,
  useApiClient,
} from '@ori/global-api-client-react';
import useSWR from 'swr';

import { useConfiguration, useNotificationData } from '../../../contexts';
import { useTranslations } from '../../../hooks/useTranslations_simplified-registration-BrandPartner';
import { MessageType } from '../../../interfaces';
import { FetchResult } from '../../FetchResult';
import { TranslationKey } from '../../TranslationKey_simplified-registration-BrandPartner';

async function fetchSponsorInfoData(api: ApiClient, registrationIdParam: string) {
  const emptySponsorInfoData: GlobalCustomerRegistrationsRegistrationSponsorInfoDto = {};

  try {
    const response = await getCustomerRegistrationSponsorDetailsSponsorInfo(api, registrationIdParam);

    return new FetchResult<GlobalCustomerRegistrationsRegistrationSponsorInfoDto>(response.status, response.data);
  } catch (error: unknown) {
    return FetchResult.errorFor(emptySponsorInfoData);
  }
}

export const useSponsorInfoData = (refetchKey?: string) => {
  const { registrationId } = useConfiguration();
  const { formatMessage } = useTranslations();
  const api = useApiClient();
  const {
    context: { notificationData },
  } = useNotificationData();
  const { setNotificationData } = notificationData;

  const errorMeesage = formatMessage(TranslationKey.cannotGetData);

  return useSWR(
    [registrationId, refetchKey, 'sponsorInfoData'],
    async () => {
      const result = await fetchSponsorInfoData(api, registrationId);
      if (result.isSuccess() && result.response) {
        return result.response;
      }
      throw new Error('request failed fetch sponsor info data');
    },
    {
      onError(err?: FetchResult) {
        if (err) {
          setNotificationData({
            isOpen: true,
            message: errorMeesage,
            type: MessageType.error,
            messageId: 'cannotGetData',
          });
        }
      },
    },
  );
};
